/* eslint-disable react/destructuring-assignment */
import React from "react"
import { useSelector } from "react-redux"

import { CcReviewReviewHistory } from "server/models"
import {
    StoreType,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
} from "client/components"
import {
    NextRevision,
    Bold,
} from "./styled"

export const HistoryNextRevision = ({
    history,
}: HistoryProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const reviewHistory = history as CcReviewReviewHistory
    let nextRevision = reviewHistory.nextRevision && reviewHistory.nextRevision.trim()
    nextRevision = nextRevision && nextRevision.length > 0 ? nextRevision : null

    if (!nextRevision) return null
    return (
        <NextRevision>
            <Bold>{`${lang.addressedInRevision}:`}</Bold>
            {nextRevision}
        </NextRevision>
    )
}

export const HistoryNextRevisionPdfExport = (
    history: HistoryType,
    lang: LangType,
) => {
    const reviewHistory = history as CcReviewReviewHistory
    let nextRevision = reviewHistory.nextRevision && reviewHistory.nextRevision.trim()
    nextRevision = nextRevision && nextRevision.length > 0 ? nextRevision : null

    if (!nextRevision) return null
    return ({
        text: [
            {
                text: `${lang.addressedInRevision}: `,
                bold: true,
            },
            { text: nextRevision },
        ],
    })
}
